import React, { useState } from 'react';
import { Typography, Row, Col, List, Space, Dropdown, Menu, Spin, Button, Modal } from 'antd';
import { syncZendeskToJira, UpdateFeedbackStatus } from './gqls'
import Client from '../../../../lib/gqlClient';
import { useNavigate } from 'react-router-dom';
import { DownOutlined } from '@ant-design/icons';
import { message } from 'antd'
const { Paragraph } = Typography;
const FeedbackItem = (props) => {
    const navigate = useNavigate();
    const [isCreate, setIsCreate] = useState(false);
    const [openJiraSync, setOpenJiraSync] = useState(false);
    const [openIgnore, setOpenIgnore] = useState(false);
    const [content, setContent] = useState('');

    //Model弹窗
    const [jiraSyncModelproject, setJiraSyncModelproject] = useState([{}])
    const [jiraSyncModelIssueType, setjiraSyncModelIssueType] = useState([{}])
    const [jiraMembersList, setJiraMembersList] = useState([{}])

    const [jiraSyncProject, setJiraSyncProject] = useState('MyVitals4')
    const [jiraSyncIssueType, setJiraSyncIssueType] = useState('Select issue type')
    const [JiraMembers, setJiraMembers] = useState('Please select')
    const [modalData, setModalData] = useState('Are you sure you want to ignore')
    React.useEffect(() => {
        if (props.item.comment.substring(0, 8) === 'customer') {
            var datas = props.item.comment.split('\r\n')[0].substring(9, props.item.comment.split('\r\n')[0].length - 25)
            var data = datas.split('***files***')//裁剪附件
            setContent(data[0])
        } else {
            setContent(props.item.comment)
        }
    })
    //跳转详情
    function onClick(data) {
        props.showDetail(data)
    }
    function onShowJiraSyncModal() {
        if (props.item.ticketStatus === 'IGNORE' || props.item.jiraID !== null) {
            return
        }
        var list = [{}]
        props.jira.map((item, index) => {
            list[index] = { key: index, label: item.projectName }
        })
        setJiraSyncModelproject(list)

        setIssueType("MyVitals4")

        var list2 = [{}]
        props.JiraMembers.map((item, index) => {
            list2[index] = {
                key: index,
                label: (
                    <div>
                        <div style={{ fontSize: '14px' }}>{item.name}</div>
                        <div style={{ fontSize: '12px', color: '#BFBFBF' }}>{item.email}</div>
                    </div>)
            }
        })
        setJiraMembersList(list2)

        setOpenJiraSync(true)

    }
    const onQueryZendeskToJira = (data) => {
        let id
        let issueType
        let accountId
        props.jira.map((item, index) => {
            if (item.projectName === jiraSyncProject) {
                id = item.projectId
                item.issueType.map((item1, index) => {
                    if (jiraSyncIssueType === item1.display) {
                        issueType = item1.id
                    }
                })
            }
        })

        props.JiraMembers.map((item) => {
            if (item.email === JiraMembers) {
                accountId = item.accountId
            }
        })
        setOpenJiraSync(false)
        props.setLoding(true)
        Client(
            '',
            {
                syncZendeskToJiraId: data.id,
                projectId: id,
                issueType: issueType,
                assignTo: accountId
            },
            syncZendeskToJira
        ).then((res) => {
            props.setLoding(false)
            //刷数据
            props.onRefresh()
            if (res != null && res.data.syncZendeskToJira.jiraId !== null) {
                message.success('Sync to Jira successfull')
            } else {
                message.error('Sync to Jira failed')
            }
        }).catch(e => {
            message.error('Sync to Jira failed')
            props.setLoding(false)
            props.onRefresh()
        })
    }

    const itemsJiraSyncProjectClick = ({ key }) => {
        const name = jiraSyncModelproject[key].label
        setJiraSyncProject(name)
        setIssueType(name)
    };
    const itemsJiraSyncIssueTypeClick = ({ key }) => {
        setJiraSyncIssueType(jiraSyncModelIssueType[key].label)

    };
    const itemsJiraMembersClick = ({ key }) => {
        console.log(key, props.JiraMembers[key])
        setJiraMembers(props.JiraMembers[key].email)
    };
    function onShowIgnoreModal(data) {
        if (data.ticketStatus === 'IGNORE') {
            setModalData('Are you sure you want to unignore')
        } else {
            setModalData('Are you sure you want to ignore')
        }
        setOpenIgnore(true)
    }
    const onHideIgnoreModal = (data) => {
        setOpenIgnore(false)
        props.setLoding(true)
        Client(
            '',
            {
                updateFeedbackStatusId: data.id,
                status: data.ticketStatus === 'IGNORE' ? "New" : "IGNORE",

            },
            UpdateFeedbackStatus
        ).then((res) => {
            //刷数据
            props.setLoding(false)
            props.onRefresh()
            if (res != null) {
                if (res.data.updateFeedbackStatus.ticketStatus === 'IGNORE') {
                    message.success('Ignore successfully')
                } else if (res.data.updateFeedbackStatus.ticketStatus === 'New') {
                    message.success('Unignore successfully')
                }

            } else {
                if (data.ticketStatus === 'IGNORE') {
                    message.error('Unignore failed')
                } else if (data.ticketStatus === 'New') {
                    message.error('Ignore failed')
                }
            }
        }).catch(e => {
            message.error('Network timeout, please try again')
            props.setLoding(false)
            props.onRefresh()
        })
    }
    function setIssueType(name) {
        var list1 = [{}]
        props.jira.map((item, index) => {
            if (item.projectName === name) {
                item.issueType.map((item1, index1) => {
                    list1[index1] = { key: index1, label: item1.display }
                })
            }
        })
        setjiraSyncModelIssueType(list1);
        setJiraSyncIssueType('Select issue type');
    }
    return (

        <List.Item>
            <Row style={Styles.item}>
                <Col span={2} style={Styles.listTitleText}>
                    <div style={{ marginLeft: '8px', }}>{props.item.ticketId}</div>
                </Col>
                <Col span={4} style={Styles.listTitleText}>
                    <div  >{props.item.level1}</div>
                    <div  >{props.item.level2}</div>
                </Col>
                <Col span={3} style={Styles.listTitleText}>
                    <div  >{props.item.deviceType}</div>
                    <div  >{props.item.deviceModel}</div>
                    <div  >{props.item.fv}</div>
                    <div  >{props.item.hv}</div>
                    <div  >{props.item.mac}</div>
                </Col>
                <Col span={4} style={Styles.listTitleText}>
                    <div  >{props.item.appVersion}</div>
                    <div >{props.item.phoneModel}</div>
                    <div  >{props.item.phoneOS}</div>
                </Col>
                <Col span={6} style={Styles.listTitleText}>
                    <Paragraph style={{ minHeight: '22px' }}>{content}</Paragraph>
                </Col>
                <Col span={3} style={Styles.listTitleText}>
                    <div  >{props.item.createdAt.substring(0, 10)}</div>
                    <div  >{props.item.createdAt.substring(11, 19)}</div>
                </Col>
                <Col span={2} style={Styles.listTitleText}>
                    <a onClick={() => onClick(props.item)}>
                        <Space style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', color: '#2657F9' }}>
                            View
                        </Space>
                    </a>
                    <a onClick={() => onShowJiraSyncModal(props.item)}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', color: (props.item.ticketStatus === 'IGNORE' || props.item.jiraID !== null) ? 'rgba(0, 0, 0, 0.25)' : '#2657F9' }}>
                            Jira Sync
                        </div>
                    </a>
                    <Modal
                        closable={false}
                        centered
                        open={openJiraSync}
                        footer={null}
                        width={441}
                        destroyOnClose={true}
                        maskStyle={{ animation: 'none', background: 'ffffff', opacity: '0.5', padding: '0px' }}
                        bodyStyle={{ padding: '0px', width: '441px', background: 'ffffff', borderRadius: '10px' }}
                        style={{ borderRadius: "10px", overflow: "auto" }}>
                        <Spin size="large" tip="Loading..." spinning={isCreate} >

                            <div style={{ fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '66px' }}>Jira Sync</div>
                            <div style={{ height: '1px', width: '441px', background: '#E9E9E9' }}></div>
                            <div style={{ fontSize: '14px', lineHeight: '22px', marginTop: '30px', marginLeft: '67px', }}>Project</div>
                            <Dropdown overlayStyle={{ maxHeight: '300px', overflowY: 'auto' }} overlay={<Menu onClick={itemsJiraSyncProjectClick} items={jiraSyncModelproject} />} style={{ width: '307px', height: '40px', marginLeft: '67px', marginTop: '6px' }}>
                                <Button style={{ padding: '0px', width: '307px', height: '40px', color: 'rgba(0, 0, 0, 0.25)', marginLeft: '67px', marginTop: '6px' }} >
                                    <Space>
                                        <div style={{ fontSize: '14px', color: "#000", width: '260px', height: '40px', display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                            {jiraSyncProject}</div>
                                        <DownOutlined />
                                    </Space>
                                </Button>
                            </Dropdown>
                            <Space style={{ fontSize: '14px', lineHeight: '22px', marginTop: '30px', marginLeft: '67px', }}>Issue Type</Space>
                            <Dropdown overlayStyle={{ maxHeight: '300px', overflowY: 'auto' }} overlay={<Menu onClick={itemsJiraSyncIssueTypeClick} items={jiraSyncModelIssueType} />} style={{ width: '307px', height: '40px', marginLeft: '67px', marginTop: '6px' }}>
                                <Button style={{ padding: '0px', width: '307px', height: '40px', color: 'rgba(0, 0, 0, 0.25)', marginLeft: '67px', marginTop: '6px' }} >
                                    <Space>
                                        <div style={{ fontSize: '14px', color: jiraSyncIssueType === "Select issue type" ? "rgba(0, 0, 0, 0.25)" : "#000", width: '260px', height: '40px', display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                            {jiraSyncIssueType}</div>
                                        <DownOutlined />
                                    </Space>
                                </Button>
                            </Dropdown>
                            <Space direction="vertical" style={{ fontSize: '14px', lineHeight: '22px', marginTop: '30px', marginLeft: '67px', }}>Assign to</Space>
                            <Dropdown
                                placement='bottom'
                                autoAdjustOverflow={false}
                                overlay={<
                                    Menu onClick={itemsJiraMembersClick}
                                    items={jiraMembersList}
                                    dropdownRender={(menu) => (
                                        <div className="dropdown-content">
                                            {menu}
                                        </div>
                                    )}
                                />}
                                overlayStyle={{ maxHeight: '300px', overflowY: 'auto' }}
                                style={{ width: '307px', height: '40px', marginLeft: '67px', marginTop: '6px' }}>
                                <Button style={{ padding: '0px', width: '307px', height: '40px', color: 'rgba(0, 0, 0, 0.25)', marginLeft: '67px', marginTop: '6px' }} >
                                    <Space>
                                        <div style={{ fontSize: '14px', color: JiraMembers === "Please select" ? "rgba(0, 0, 0, 0.25)" : "#000", width: '260px', height: '40px', display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                            {JiraMembers}</div>
                                        <DownOutlined />
                                    </Space>
                                </Button>
                            </Dropdown>
                            <Row style={{ marginTop: '30px', paddingBottom: '30px', marginRight: '67px', display: 'flex', justifyContent: 'right' }}>
                                <Col>
                                    <Button onClick={() => setOpenJiraSync(false)} style={{ fontSize: '14px', width: '80px', height: '32px' }}>取消</Button>
                                </Col>
                                <Col>
                                    <Button onClick={() => onQueryZendeskToJira(props.item)} style={{ fontSize: '14px', background: '#FF5300', color: 'white', width: '80px', height: '32px', marginLeft: '14px' }}>创建</Button>
                                </Col>
                            </Row>
                        </Spin>
                    </Modal>
                    <a onClick={() => onShowIgnoreModal(props.item)}>
                        <Space style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', color: props.item.ticketStatus === 'IGNORE' ? 'rgba(0, 0, 0, 0.25)' : '#D61B1B' }}>
                            Ignore
                        </Space>
                    </a>
                    <Modal
                        closable={false}
                        centered
                        open={openIgnore}
                        footer={null}
                        width={320}
                        destroyOnClose={true}
                        maskStyle={{ animation: 'none', background: 'ffffff', opacity: '0.5', padding: '0px' }}
                        bodyStyle={{ padding: '0px', width: '320px', background: 'ffffff', borderRadius: '10px' }}
                        style={{ borderRadius: "10px", overflow: "auto" }}
                    >
                        <div style={{ fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '112px' }}>
                            <div>
                                <div >{modalData}</div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>this ticket？</div>

                            </div>
                        </div>

                        <div style={{ height: '1px', width: '320px', background: 'rgba(0, 0, 0, 0.1)' }}></div>
                        <Row>
                            <Col span={'159.5px'}>
                                <Button type="text" onClick={() => setOpenIgnore(false)} style={{ color: 'rgba(0, 0, 0, 0.25)', fontSize: '16px', width: '159.5px', height: '56px' }}>Cancel</Button>
                            </Col>
                            <Col span={'1px'}>
                                <div style={{ height: '56px', width: '1px', background: 'rgba(0, 0, 0, 0.1)' }}></div>
                            </Col>
                            <Col span={'159.5px'}>
                                <Button type="text" onClick={() => onHideIgnoreModal(props.item)} style={{ fontSize: '16px', width: '159.5px', height: '56px' }}>Yes</Button>
                            </Col>
                        </Row>

                    </Modal>
                </Col>
            </Row>
        </List.Item >
    );

}
const Styles = {
    item: {
        minHeight: '108px',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
}
export default FeedbackItem